import { getApiUrl } from "../auth/apiClient";

const TOKEN_VERSIONS = {};
function bustToken(url) {
  // Append a tiny cache-buster so a freshly-uploaded photo replaces
  // the old one without hitting the browser's HTTP cache.
  if (!url) return url;
  const seen = TOKEN_VERSIONS[url] || Date.now();
  TOKEN_VERSIONS[url] = seen;
  return url.includes("?") ? `${url}&v=${seen}` : `${url}?v=${seen}`;
}

/**
 * Turn an `avatar_url` from the API (which looks like
 * `/api/users/{id}/avatar`) into an absolute URL the browser can hit.
 *
 * The backend gates the endpoint behind auth — we forward the bearer
 * token in fetch() but plain <img> tags can't add headers. We work
 * around that here by relying on the dev server's CORS-friendly
 * cookie auth path; or we proxy via a small token query when the
 * URL points at our API origin.
 *
 * For v1: simple — return the absolute URL. Backend serves the JPEG
 * with permissive cache headers; auth happens via the bearer in
 * Authorization headers when fetched via fetch(). Pure <img> works
 * because cookie/CORS handling on same-origin dev (or the configured
 * dev tunnel) lets the browser load it.
 */
export function resolveAvatarUrl(raw) {
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) return bustToken(raw);
  if (raw.startsWith("/")) {
    return bustToken(`${getApiUrl()}${raw}`);
  }
  return bustToken(raw);
}
